import {
  Component,
  ElementRef,
  Input,
  Output,
  QueryList,
  SimpleChange,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  inject,
} from "@angular/core";
import { trigger, style, animate, transition } from "@angular/animations";
import { ModalService } from "@src/app/helpers/modal.service";
import { UieventhubService } from "@src/app/helpers/uieventhub/uieventhub.service";
import { Project } from "@src/app/models/project";
import { Projectmember } from "@src/app/models/projectmember";
import { QuillEditorComponent } from "ngx-quill";
import { Task } from "@src/app/models/task";
import { ProjecttaskService } from "../projecttask/service/projecttask.service";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { AuthorizationService } from "@src/app/helpers/authorization.service";
import { untilDestroyed } from "@ngneat/until-destroy";
import { UntilDestroy } from "@ngneat/until-destroy";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";
import { FormService } from "@src/app/components/forms/service/form.service";
import { FormTemplate } from "@src/app/components/forms/models/form.model";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-taskeditmodal",
  templateUrl: "./taskeditmodal.component.html",
  styleUrl: "./taskeditmodal.component.css",
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class TaskeditmodalComponent {
  @Output() result: string;
  @Input() task: Task;
  @Input() projectMembers: Projectmember[];
  @Input() projectCustomerMembers: Projectmember[];
  @Output() modalTask: Task;
  @Output() taskstatetrack: boolean = false;
  organizationId: string;
  formIsValid: boolean;
  taskStatus: string;
  @ViewChild(QuillEditorComponent, { static: true })
  editor: QuillEditorComponent;
  acceptwarning: boolean;
  errorMessage: string;
  showSpinner: boolean;
  isCustomer: boolean = false;
  customerId: string;
  taskeditalert: boolean;
  fileInputs: string[] = [''];

  // Time tracking (timereg org module). Panel itself lives in the shared
  // app-time-tracking-panel component; this just decides whether to show it.
  timeregEnabled: boolean = false;

  // Form linking properties
  publishedForms: FormTemplate[] = [];
  loadingForms: boolean = false;
  hasPublishedForms: boolean = false;
  formTouched: boolean = false;
  
  formats = [
    "background",
    "bold",
    "color",
    "font",
    "code",
    "italic",
    "link",
    "size",
    "strike",
    "script",
    "underline",
    "blockquote",
    "header",
    "indent",
    "list",
    "align",
    "direction",
    "code-block",
    "formula",
    // 'image'
    // 'video'
  ];
  modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      ["link"],
    ],
  };

  private readonly modalService = inject(ModalService);
  private readonly ptsrv = inject(ProjecttaskService);
  private readonly auth = inject(AuthorizationService);
  private readonly datastore = inject(DatastoreService);
  private readonly uieventhub = inject(UieventhubService);
  private readonly formService = inject(FormService);

  constructor() {
    // Set organizationId early so it's available for form loading
    this.organizationId = SessionHelper.getChoosenOrg();
    
    this.uieventhub.editTask$
      .subscribe((task) => {
        console.log('[TaskEditModal] Loading task for edit:', {
          taskId: task.taskId,
          tasktype: task.tasktype,
          formTemplateId: task.formTemplateId,
          formTemplateVersion: task.formTemplateVersion,
          formTemplateName: task.formTemplateName
        });
        
        this.task = task;
        this.modalTask = { ...task }; // Use spread to create a copy with all properties
        if (this.modalTask.tasktype == 'submit' && (!this.modalTask.uploadFields || this.modalTask.uploadFields.length == 0)) {
          this.modalTask.uploadFields = [''];
        };

        this.modalTask.startdate = this.toIsoInputDate(task.startdate, task.tasktype === 'event');
        this.modalTask.duedate = this.toIsoInputDate(task.duedate, task.tasktype === 'event');
        this.modalTask.responsible = task.responsible;
        this.modalTask.description = task.description;
        this.taskstatetrack = true;

        // Load published forms and pre-select saved form after they load
        this.loadPublishedForms();

        // Recomputed on every open, not just in ngOnInit: this component is
        // constructed once and reused for every task, so a session change
        // (module enabled, org switched) made after construction would
        // otherwise never be picked up without a full page reload. The
        // panel itself (app-time-tracking-panel) reloads on its own via
        // ngOnChanges when task.taskId changes.
        this.timeregEnabled = SessionHelper.hasModule("timereg") && !this.isCustomer;
      }

      );
  }
  ngOnInit() {
    this.task = new Task();
    this.modalTask = new Task();
    // organizationId already set in constructor
    this.formIsValid = false;
    this.taskStatus = "onTrack";
    this.showSpinner = false;
    this.isCustomer = false;
    this.timeregEnabled = SessionHelper.hasModule("timereg") && !this.isCustomer;
    this.acceptwarning = true;
    this.errorMessage = undefined;
    this.taskstatetrack = false;
    this.modalTask.responsible = SessionHelper.getUserSub();
    this.modalTask.startdate = new Date().toISOString().substring(0, 10);
    this.modalTask.duedate = new Date().toISOString().substring(0, 10);
    this.modalTask.taskstate = "onTrack";
    this.modalTask.projectId = SessionHelper.getCurrentProject();
    const currentProjectId = this.task?.projectId || SessionHelper.getCurrentProject();
    const project = this.datastore.projectList
      .getValue()
      .find((x) => x.projectId == currentProjectId);
    this.customerId = project?.customer || '';

    // Load published forms for form selector
    this.loadPublishedForms();
  }
  ngOnChanges(changes: SimpleChanges) {
    //members 
    if (changes.projectMembers) {
      this.projectMembers = changes.projectMembers.currentValue;
      //console.log("Project members", this.projectMembers);
    }
    if (changes.projectCustomerMembers) {
      this.projectCustomerMembers =
        changes.projectCustomerMembers.currentValue;
      //console.log("Project customer members", this.projectCustomerMembers);
    }
  }
  saveTask() {
    if (
      !this.modalTask.title ||
      !this.modalTask.duedate ||
      !this.modalTask.startdate ||
      !this.modalTask.responsible
    ) {
      this.errorMessage = "modalvalidation.requiredfieldmissing";
    } else {
      this.showSpinner = true;
      if (!this.modalTask.description) {
        this.modalTask.description = " ";
      }
      //quill br temp fix
      this.modalTask.description = this.modalTask.description.replace(
        new RegExp("<p></p>", "g"),
        "<br>"
      );
      //quill br temp fix end

      this.taskStatus = "onTrack";
      if (
        this.modalTask.duedate == new Date().toISOString().substring(0, 10) &&
        this.task.taskstate != "Done"
      ) {
        this.taskStatus = "midt";
      }
      if (
        this.modalTask.duedate < new Date().toISOString().substring(0, 10) &&
        this.task.taskstate != "Done"
      ) {
        this.taskStatus = "overdue";
      }

      this.normalizeFormTemplatePayload(this.modalTask);
     
     // Log the task before saving to check form fields
     console.log('[TaskEditModal] Saving task:', {
       taskId: this.modalTask.taskId,
       tasktype: this.modalTask.tasktype,
       formTemplateId: this.modalTask.formTemplateId,
       formTemplateVersion: this.modalTask.formTemplateVersion,
       formTemplateName: this.modalTask.formTemplateName
     });
     
     this.ptsrv
        .saveTask(this.modalTask)
        //.pipe(untilDestroyed(this))
        .subscribe((result) => {
          //console.log("Task saved", result);
          //Newversion id
          this.task.taskId = result;
          this.modalTask.taskId = result;
          this.syncEditedTaskToDatastore();
          
          // If tasktype is 'form', create form link
          if (this.modalTask.tasktype === 'form' && this.modalTask.formTemplateId) {
            this.createFormLink(result);
          } else {
            this.showSpinner = false;
            //Update UI
            this.closeModal();
            this.taskeditalertFunc();
          }
          // this.auth.refreshPersonAuth(SessionHelper.getUserSub());
          // this.task.canEdit = true;
          // this.updateResp();
          // sessionStorage.setItem(('task_'+this.task.taskId),JSON.stringify(this.task));

          //this.uieventhub.setCurrentProjectStateChange(this.task.projectId);
          //this.ptsrv.generateStats(this.task.projectId).pipe(untilDestroyed(this)).subscribe(proj => {

          // });
        });
    }
  }

  private normalizeFormTemplatePayload(task: Task): void {
    if (task.tasktype !== 'form') {
      task.formTemplateId = undefined;
      task.formTemplateVersion = undefined;
      task.formTemplateName = undefined;
      return;
    }

    if (!task.formTemplateId) {
      return;
    }

    if (task.formTemplateId.includes('_v')) {
      const [baseId, versionPart] = task.formTemplateId.split('_v');
      const parsedVersion = parseInt(versionPart, 10);

      task.formTemplateId = baseId;
      if (!Number.isNaN(parsedVersion)) {
        task.formTemplateVersion = parsedVersion;
      }
    }

    if (task.formTemplateVersion != null) {
      task.formTemplateVersion = Number(task.formTemplateVersion);
    }
  }

  private syncEditedTaskToDatastore(): void {
    const currentTasks = this.datastore.taskList.getValue() || [];
    const updatedTaskBaseId = (this.modalTask.taskId || '').split('_')[0];

    const nextTasks = currentTasks.map((task) => {
      const existingBaseId = (task.taskId || '').split('_')[0];
      if (existingBaseId === updatedTaskBaseId) {
        return {
          ...task,
          ...this.modalTask,
          responsible: this.modalTask.responsible || task.responsible,
        };
      }
      return task;
    });

    this.datastore.taskList.next(nextTasks);
  }

  closeModal() {
    //console.log("Close modal ");
    this.modalService.close("taskeditmodal");
    this.modalTask = new Task();
  }

  willLoseAccess() {
    if (this.auth.isAuthorized("orgedit", SessionHelper.getChoosenOrg())) {
      return false;
    } else {
      if (
        this.modalTask.responsible &&
        this.modalTask.responsible != SessionHelper.getUserSub()
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
  validate() {
    if (
      this.modalTask.duedate &&
      this.modalTask.startdate &&
      this.modalTask.title &&
      this.modalTask.responsible
    ) {
      // Check form template selection when tasktype is 'form'
      if (this.modalTask.tasktype === 'form' && !this.modalTask.formTemplateId) {
        this.formIsValid = false;
        return;
      }
      
      if (
        (!this.willLoseAccess() && !this.acceptwarning) ||
        (this.willLoseAccess() && this.acceptwarning)
      ) {
        this.formIsValid = true;
      } else {
        this.formIsValid = false;
      }
    } else {
      this.formIsValid = false;
    }
  }


  trackByIndex = (_: number, __: unknown) => _;

  private toIsoInputDate(value: unknown, includeTime: boolean): string {
    if (!value) {
      return includeTime
        ? new Date().toISOString().substring(0, 16)
        : new Date().toISOString().substring(0, 10);
    }

    const parsed = new Date(String(value));
    if (Number.isNaN(parsed.getTime())) {
      return includeTime
        ? new Date().toISOString().substring(0, 16)
        : new Date().toISOString().substring(0, 10);
    }

    return includeTime
      ? parsed.toISOString().substring(0, 16)
      : parsed.toISOString().substring(0, 10);
  }

  addFileInput() {
    this.modalTask.uploadFields.push('');
  }

  removeFileInput(i: number) {
    if (this.modalTask.uploadFields.length > 1) {
      this.modalTask.uploadFields.splice(i, 1);
    } else {
      // keep one empty input
      this.modalTask.uploadFields[0] = '';
    }
  }

  taskeditalertFunc() {
    this.taskeditalert = true;
    setTimeout(() => {
      this.taskeditalert = false;
    }, 2000);
  }

  // Load published forms for form selector
  loadPublishedForms() {
    // Don't reload if already loading
    if (this.loadingForms) {
      console.log('[TaskEditModal] Already loading forms, skipping duplicate call');
      return;
    }
    
    if (!this.organizationId) {
      console.warn('[TaskEditModal] No organizationId available for loading forms');
      this.loadingForms = false;
      this.hasPublishedForms = false;
      return;
    }
    
    console.log('[TaskEditModal] Loading published forms from datastore');
    this.loadingForms = true;
    
    // Check if forms are already loaded in datastore
    const cachedForms = this.datastore.getPublishedForms();
    
    if (cachedForms && cachedForms.length > 0) {
      console.log('[TaskEditModal] Using cached forms from datastore:', cachedForms.length);
      this.publishedForms = cachedForms.sort((a, b) => {
        // Sort by name first, then by version descending
        if (a.name !== b.name) {
          return a.name.localeCompare(b.name);
        }
        return b.version - a.version;
      });
      this.hasPublishedForms = this.publishedForms.length > 0;
      this.loadingForms = false;
      // Pre-select saved form now that forms are loaded
      this.preselectSavedForm();
      return;
    }
    
    // Load from API and cache in datastore
    this.datastore.loadPublishedForms()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (forms) => {
          console.log('[TaskEditModal] Loaded forms from API:', forms?.length);
          this.publishedForms = forms.sort((a, b) => {
            if (a.name !== b.name) {
              return a.name.localeCompare(b.name);
            }
            return b.version - a.version;
          });
          this.hasPublishedForms = this.publishedForms.length > 0;
          this.loadingForms = false;
          // Pre-select saved form now that forms are loaded
          this.preselectSavedForm();
        },
        error: (err) => {
          console.error('[TaskEditModal] Error loading forms:', err);
          this.publishedForms = [];
          this.loadingForms = false;
          this.hasPublishedForms = false;
          this.errorMessage = 'Failed to load forms. Please try again.';
        }
      });
  }

  // Generate unique form key to handle multiple versions
  getFormKey(form: FormTemplate): string {
    // Use format: id_v{version} to uniquely identify a specific version
    return `${form.id}_v${form.version}`;
  }

  // Pre-select saved form when reopening task edit modal
  preselectSavedForm() {
    console.log('[TaskEditModal] preselectSavedForm called');
    console.log('[TaskEditModal] task.formTemplateId:', this.task?.formTemplateId);
    console.log('[TaskEditModal] task.formTemplateVersion:', this.task?.formTemplateVersion);
    console.log('[TaskEditModal] publishedForms count:', this.publishedForms?.length);
    
    if (this.task?.formTemplateId && this.task?.formTemplateVersion) {
      // Set the composite key for dropdown selection
      const formKey = `${this.task.formTemplateId}_v${this.task.formTemplateVersion}`;
      
      // Check if this form exists in publishedForms
      const formExists = this.publishedForms.some(
        f => this.getFormKey(f) === formKey
      );
      
      console.log('[TaskEditModal] Looking for formKey:', formKey);
      console.log('[TaskEditModal] Form exists in list:', formExists);
      console.log('[TaskEditModal] Available form keys:', this.publishedForms.map(f => this.getFormKey(f)));
      
      if (formExists) {
        this.modalTask.formTemplateId = formKey;
        this.modalTask.formTemplateVersion = this.task.formTemplateVersion;
        // Form name is already on the task from the backend - no need to look it up
        if (this.task.formTemplateName) {
          this.modalTask.formTemplateName = this.task.formTemplateName;
        }
        
        console.log('[TaskEditModal] Pre-selected saved form:', {
          formKey,
          modalTask_formTemplateId: this.modalTask.formTemplateId,
          formTemplateName: this.task.formTemplateName
        });
      } else {
        console.warn('[TaskEditModal] Form not found in published forms list');
      }
    } else {
      console.log('[TaskEditModal] No form to pre-select');
    }
  }

  // Handle form selection
  onFormSelected() {
    console.log('[TaskEditModal] onFormSelected called, formKey:', this.modalTask.formTemplateId);
    
    // formTemplateId is now the composite key in format: id_v{version}
    if (this.modalTask.formTemplateId) {
      // Parse the key to extract id and version
      const [baseId, versionPart] = this.modalTask.formTemplateId.split('_v');
      const version = parseInt(versionPart);
      
      const selectedForm = this.publishedForms.find(
        (f) => f.id === baseId && f.version === version
      );
      console.log('[TaskEditModal] Selected form found:', selectedForm);
      
      if (selectedForm) {
        // Keep the composite key in formTemplateId for dropdown binding
        // Store version and name from the selected form
        this.modalTask.formTemplateVersion = selectedForm.version;
        this.modalTask.formTemplateName = selectedForm.name;
        console.log('[TaskEditModal] Updated form metadata:', {
          formTemplateId: this.modalTask.formTemplateId,
          formTemplateVersion: this.modalTask.formTemplateVersion,
          formTemplateName: this.modalTask.formTemplateName
        });
      }
    }
    // Don't call validate() here - it will be called when saving
  }

  // Create form link after task save
  createFormLink(taskId: string) {
    // Extract base ID from composite key (format: id_v{version})
    const baseId = this.modalTask.formTemplateId?.includes('_v') 
      ? this.modalTask.formTemplateId.split('_v')[0]
      : this.modalTask.formTemplateId;
    
    const linkRequest = {
      templateId: baseId,
      templateVersion: this.modalTask.formTemplateVersion,
      templateName: this.modalTask.formTemplateName
    };
    
    console.log('[TaskEditModal] Creating form link with:', linkRequest);
    
    this.formService
      .linkFormToTask(this.organizationId, taskId, linkRequest)
      
      .subscribe({
        next: () => {
          console.log('Form link created successfully');
          this.showSpinner = false;
          this.closeModal();
          this.taskeditalertFunc();
        },
        error: (err) => {
          console.error('Error creating form link:', err);
          this.showSpinner = false;
          this.errorMessage = 'Task saved but failed to link form: ' + 
            (err.error?.message || err.message);
          // Keep modal open so user can retry or cancel
        }
      });
  }
}
